/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XPTransactionHistoryItem
 */
export interface XPTransactionHistoryItem {
    /**
     * Transaction ID
     * @type {string}
     * @memberof XPTransactionHistoryItem
     */
    id?: string;
    /**
     * XP amount (positive or negative)
     * @type {number}
     * @memberof XPTransactionHistoryItem
     */
    amount?: number;
    /**
     * Transaction type (DEBIT = earned, CREDIT = spent)
     * @type {string}
     * @memberof XPTransactionHistoryItem
     */
    type?: XPTransactionHistoryItemTypeEnum;
    /**
     * XP transaction subject/source
     * @type {string}
     * @memberof XPTransactionHistoryItem
     */
    subject?: string;
    /**
     * Human-readable description
     * @type {string}
     * @memberof XPTransactionHistoryItem
     */
    description?: string;
    /**
     * Transaction timestamp
     * @type {Date}
     * @memberof XPTransactionHistoryItem
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const XPTransactionHistoryItemTypeEnum = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT'
} as const;
export type XPTransactionHistoryItemTypeEnum = typeof XPTransactionHistoryItemTypeEnum[keyof typeof XPTransactionHistoryItemTypeEnum];


/**
 * Check if a given object implements the XPTransactionHistoryItem interface.
 */
export function instanceOfXPTransactionHistoryItem(value: object): value is XPTransactionHistoryItem {
    return true;
}

export function XPTransactionHistoryItemFromJSON(json: any): XPTransactionHistoryItem {
    return XPTransactionHistoryItemFromJSONTyped(json, false);
}

export function XPTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): XPTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'type': json['type'] == null ? undefined : json['type'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function XPTransactionHistoryItemToJSON(json: any): XPTransactionHistoryItem {
    return XPTransactionHistoryItemToJSONTyped(json, false);
}

export function XPTransactionHistoryItemToJSONTyped(value?: XPTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'type': value['type'],
        'subject': value['subject'],
        'description': value['description'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

